import React from 'react'
import {Grid} from '@material-ui/core'

import DataComponent from 'EurestoComponents/DataComponents'
import Input from 'Components/Input'
import Select from 'Components/Select'
import Switch from 'Components/Switch'

import EurestoDiv from 'EurestoComponents/EurestoDiv'

import Constants from 'EurestoFonction/Constants'
import User from 'EurestoClass/User'

import ApiRequest from 'EurestoApi/ApiRequest'
import project from 'EurestoConfig/project.config'

import moment from 'moment'

import Utils from 'EurestoFonction/Utils'

import Data from 'EurestoClass/Data'

import MainForm from 'EurestoComponents/MainForm'
import PhoneInput from 'Components/PhoneInput'

moment.locale('fr')

export default class FicheContact extends React.Component {

  constructor (props) {
    super(props)

    let options = []
    Data.list(Constants.module.COMMUN, Constants.donnee.langue, { traduction: 1 }).map((data, index) => {
      options.push({
        value: data.id,
        label: data.libelle
      })
    })
    this.state = {
      optionsLangue: options,
      UserTabSelected: 0,
      compte: User.User.get()
    }
  }

  handleContactStateChange = (data, name) => {
    User.User.set({
      ...User.User.get(),
      ...(name === 'picture' && {
        media_id: data.id,
        media_lien: data.media_lien
      } || {
        [name]: data,
      })
    })
  }

  handleSaveConfiguration = () => {
    ApiRequest(project.api + 'configuration', {
      requete: 'user',
      action: 'set',
      ...User.User.get(),
      entite: User.User.get().entite || 1,
      media_id: User.User.get().media_id || undefined
    })
  }

  handleCancel = _ => {
    User.User.set({
      ...this.state.compte,
    })
    User.ColorWebSite.change()
    this.setState({
      key: Utils.getRandomNumber()
    })
  }

  handleChange = (event, value) => {
    this.setState({ UserTabSelected: value })
  }

  render () {
    return <MainForm key={this.state.key + '_form_' + this.state.disabled}
                     mainTabProps={{
                       style: {
                         padding: '0 65px 0 35px'
                       }
                     }}
                     isAllow={{
                       delete: false,
                       update: false,
                       add: false,
                       cancel: false
                     }}
                     libelle={User.User.get().libelle}
                     action={this.state.UserTabSelected === 0 && 'update' || 'view'}
                     eurestoBodyStyle={{ padding: 0 }}
                     style={{
                       padding: 10,
                       paddingTop: 0,
                       top: 0,
                       position: 'relative'
                     }}
                     onSave={this.handleSaveConfiguration}
                     onCancel={this.handleCancel}
                     libelleAdd={EurestoI18n.t('commun:Nouveau contact')}
                     children={this.FicheChildren}
                     handleChange={this.handleChange}
                     value={this.state.UserTabSelected}
                     tabs={[{
                       value: 0,
                       label: EurestoI18n.t('Informations'),
                       component: this.TabInformation
                     }, {
                       value: 2,
                       label: EurestoI18n.t('Mot de passe'),
                       component: this.TabMotDePasse,
                     }]} general={this.FicheChildren}
    />
  }

  FicheChildren = () => {
    return <Grid key={this.state.key_form} container justify={'flex-start'} alignContent={'flex-start'}
                 alignItems={'stretch'}
                 style={{
                   margin: 0,
                   padding: 7.5,
                   paddingTop: 0,
                   maxHeight: '100%',
                   overflowY: 'auto',
                   overflowX: 'hidden',
                   textAlign: 'left'
                 }}
                 spacing={0}>
      <DataComponent
        onChange={this.handleContactStateChange}
        name="picture"
        avatarStyle={{ borderRadius: 20, width: 128, height: 128 }}
        disabled={this.state.disabled}
        data={{ lien: User.User.get().media_lien, id: User.User.get().media_id }}
        type={Constants.typeSaisie.Picture}
        defineData={true}
        object={{
          picture: User.User.get().media_lien && {
            lien: User.User.get().media_lien,
            id: User.User.get().media_id
          } || { id: undefined, link: undefined },
          id: User.User.get().id,
        }}/>
      <DataComponent
        title={EurestoI18n.t('crm:Civilité')}
        name="civilite_id"
        disabled={this.state.disabled}
        type={Constants.typeSaisie.ComboSimple}
        onChange={this.handleContactStateChange}
        inline
        data={User.User.get().civilite_id}
        object={Constants.donnee.civilite}
        module={Constants.module.COMMUN}
        search={{ type: 1 }}
      />
      <Input
        onChange={this.handleContactStateChange}
        name="nom"
        inline
        type="text"
        className="upText"
        value={User.User.get().nom}
        title={EurestoI18n.t('crm:Nom')}
      />
      <Input
        onChange={this.handleContactStateChange}
        name="prenom"
        inline
        type="text"
        value={User.User.get().prenom}
        title={EurestoI18n.t('crm:Prénom')}
      />
      <Input
        onChange={this.handleContactStateChange}
        name="email"
        inline
        type="text"
        disabled={true}
        value={User.User.get().email}
        title={EurestoI18n.t('crm:E-mail')}
      />
      <PhoneInput onChange={this.handleContactStateChange} name='fixe' inline
                  value={User.User.get().fixe} title={EurestoI18n.t('crm:Portable')}/>
      <PhoneInput onChange={this.handleContactStateChange} name='portable' inline
                  value={User.User.get().portable} title={EurestoI18n.t('crm:Portable')}/>
    </Grid>
  }

  TabInformation = () => {
    return (
      <EurestoDiv title="Global" expandable={true} expanded={true}>
        <Grid container style={{ margin: 0, padding: 0 }} spacing={0} direction="row" justify="flex-start"
              alignItems="stretch">
          <Grid item xs={6} style={{ margin: 0, padding: 5 }}>
            <Select
              title={EurestoI18n.t('commun:Thème')}
              onChange={(data) => {
                User.User.set({
                  ...User.User.get(),
                  theme_id: data
                })
                User.ColorWebSite.change()
                this.setState({
                  key: Utils.getRandomNumber()
                })
              }} options={
              Object.keys(Constants.themeUI).map(key => {
                return {
                  label: Constants.themeUI[key],
                  value: parseInt(key)
                }
              })} value={User.User.get().theme_id}/>
          </Grid>
          <Grid item xs={6} style={{ margin: 0, padding: 5 }}>
            <Switch onChange={val => {
              User.User.set({
                ...User.User.get(),
                list_view: val ? 0 : 1
              })
              this.setState({
                key: Utils.getRandomNumber()
              })
            }}
                    checked={User.User.get().list_view === 0 || User.User.get().list_view === '0'}
                    title={EurestoI18n.t('commun:Card visualisation')}/>
          </Grid>
          <Grid item xs={6} style={{ margin: 0, padding: 5 }}>
            <Select
              title={EurestoI18n.t('commun:Langue par défaut')}
              onChange={(data) => {
                User.User.set({
                  ...User.User.get(),
                  langue_id: data
                })
                this.setState({
                  key: Utils.getRandomNumber()
                })
              }} options={this.state.optionsLangue} value={User.User.get().langue_id}/>
          </Grid>
          <Grid item xs={6} style={{ margin: 0, padding: 5 }}>
            <Switch onChange={val => {
              User.User.set({
                ...User.User.get(),
                saisie_langue_defaut: val ? 0 : 1
              })
              this.setState({
                key: Utils.getRandomNumber()
              })
            }}
                    checked={User.User.get().saisie_langue_defaut === 0 || User.User.get().saisie_langue_defaut === '0'}
                    title={EurestoI18n.t('commun:Saisie multilangue')}/>
          </Grid>
          {
            User.User.get().saisie_langue_defaut === 0 && <Grid item xs={6} style={{ margin: 0, padding: 5 }}>
              <Select
                name={'langues'}
                multiple
                title={EurestoI18n.t('commun:Langues possible à Traduire')}
                onChange={this.handleContactStateChange}
                options={this.state.optionsLangue} value={User.User.get().langues || [1]}/>
            </Grid>
          }
          <Grid item xs={6} style={{ margin: 0, padding: 5 }}>
            <Switch onChange={val => {
              User.User.set({
                ...User.User.get(),
                visu_ticket_ferme: val
              })
              this.setState({
                key: Utils.getRandomNumber()
              })
            }}
                    checked={User.User.get().visu_ticket_ferme}
                    title={EurestoI18n.t('commun:Afficher les tickets fermés')}/>
          </Grid>
          <Grid item xs={6} style={{ margin: 0, padding: 5 }}>
            <Switch onChange={val => {
              User.User.set({
                ...User.User.get(),
                regroupement_tache: val
              })
              this.setState({
                key: Utils.getRandomNumber()
              })
            }}
                    checked={User.User.get().regroupement_tache}
                    title={EurestoI18n.t('commun:Regrouper les tâches par ticket/Dossier/Classeur')}/>
          </Grid>
        </Grid>
      </EurestoDiv>
    )
  }

  TabMotDePasse = () => {
    return (
      <EurestoDiv buttonsLeft={[{
        title: 'Enregistrer',
        className: 'EurestoText--text EurestoSecondary',
        icon: ' ei-commun_valider',
        cb: this.SaveNewPassword
      }]} title="Changement de Mot de Passe" expandable={true} expanded={true} xs={6}>
        <Grid container style={{ margin: 0, padding: 0 }} spacing={0} direction="column" justify="center"
              alignItems="stretch">
          <Grid item style={{ margin: 0, padding: 10 }} xs>
            <Input title="Nouveau mot de passe" type="password" value={this.state.password1} name="password1"
                   onChange={this.handlePaswwordChange}/>
          </Grid>
          <Grid item style={{ margin: 0, padding: 10 }} xs>
            <Input title="Confirmer le nouveau mot de passe" type="password" value={this.state.password2}
                   name="password2"
                   onChange={this.handlePaswwordChange}/>
          </Grid>
        </Grid>
      </EurestoDiv>
    )
  }

  handlePaswwordChange = (val, name) => {
    this.setState({
      [name]: val
    })
  }

  SaveNewPassword = () => {
    if (this.state.password1 === '' || this.state.password2 === '') {
      alert('Merci de bien vouloir renseigner tous les champs nécessaire')
    } else {
      ApiRequest(project.api + 'configuration', {
        requete: 'user',
        action: 'change_password',
        password1: this.state.password1,
        password2: this.state.password2
      })
        .then((result) => {
          this.setState({
            password1: '',
            password2: '',
          })
        })
        .catch((err) => {
          console.log(err)
        })
    }
  }

}





// WEBPACK FOOTER //
// ./app/App/Page/Utilisateur/Compte.js